import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { guEvents } from "@/mocks/events";

const CONTACT_EMAIL = "guatian@example.com";

const PRINCIPLES = [
  {
    icon: "ri-eye-off-line",
    title: "只整理公开信息",
    desc: "我们不做独家爆料，也不碰私人信息。所有内容都来自公开可见的帖子、直播回放和评论区。",
  },
  {
    icon: "ri-scales-3-line",
    title: "呈现但不定性",
    desc: "评论区观点我们会如实标注来源和比例，但不会替任何一方下定论，结论留给读者自己。",
  },
  {
    icon: "ri-chat-check-line",
    title: "评论优先于通稿",
    desc: "相比官方声明，我们更相信高赞评论里的细节。因为评论区往往比正文更接近真实反应。",
  },
  {
    icon: "ri-refresh-line",
    title: "出错就改",
    desc: "如果有人指出内容失实，我们会核实并第一时间修正或下架，不删帖、不装死。",
  },
];

const REVIEWS = [
  {
    name: "熬夜冠军",
    role: "追瓜三年",
    content:
      "以前刷半天短视频还不知道发生了什么，现在看瓜田一页就明白了，风向、神评、比例都有，效率高太多。",
  },
  {
    name: "不站队路人",
    role: "只想看热闹",
    content:
      "最喜欢的一点是它不煽动情绪。同样的评论支持反对都摆出来，看完不会觉得被带节奏。",
  },
  {
    name: "数据控",
    role: "关注舆情",
    content:
      "情绪比例这个功能很实用，能一眼看出这场瓜的反转点在哪。比单纯看热搜榜有意义多了。",
  },
];

export default function About() {
  const featured = guEvents.slice(0, 3);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "关于瓜田观察",
      inLanguage: "zh-CN",
      description:
        "瓜田观察是一个以评论区为切入点的网红吃瓜资讯聚合站，坚持整理公开信息、呈现不站队的内容原则。",
      mainEntity: {
        "@type": "Organization",
        name: "瓜田观察",
        description: "以评论区为切入点的网红吃瓜资讯聚合站。",
        email: CONTACT_EMAIL,
        url: "https://2ndhair.com.cn/",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://2ndhair.com.cn/" },
        { "@type": "ListItem", position: 2, name: "关于我们", item: "https://2ndhair.com.cn/about" },
      ],
    },
  ];

  return (
    <Layout>
      <Seo
        title="关于我们 - 瓜田观察的品牌定位与内容原则"
        description="了解瓜田观察的品牌定位、发展理念、内容原则与用户口碑。我们以评论区为切入点整理网红吃瓜事件，坚持只整理公开信息、呈现但不站队。"
        keywords="瓜田观察,关于我们,内容原则,吃瓜群众,评论区风向"
        path="/about"
        jsonLd={jsonLd}
      />

      <section className="border-b border-background-200 bg-foreground-950">
        <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
          <div className="[&_a]:!text-background-400 [&_span]:!text-background-400">
            <Breadcrumb items={[{ label: "关于我们" }]} />
          </div>
          <div className="mt-6 grid grid-cols-1 gap-8 lg:grid-cols-[1.5fr_1fr] lg:items-end">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                <i className="ri-fire-fill text-sm" />
                关于瓜田观察
              </span>
              <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
                一个把评论区
                <br />
                当成正文来看的吃瓜站
              </h1>
              <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-300 md:text-base">
                瓜田观察诞生于一个很朴素的观察：大多数人看瓜，真正想知道的不是「发生了什么」，而是「大家怎么看」。所以我们把评论区提到第一位，用风向、比例和高赞原话，还原一场瓜在网友眼里的真实模样。
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { label: "收录评论", value: "19.4 万" },
                { label: "覆盖专题", value: "326 场" },
                { label: "风向更新", value: "每 6 小时" },
                { label: "不站队", value: "始终" },
              ].map((item) => (
                <div
                  key={item.label}
                  className="rounded-lg border border-foreground-800 bg-foreground-900 px-4 py-4"
                >
                  <p className="font-heading text-xl font-black text-accent-400">{item.value}</p>
                  <p className="mt-1 text-xs text-background-400">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="border-b border-background-200 bg-background-50">
        <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-2">
          <div>
            <span className="text-xs font-bold tracking-[0.25em] text-primary-600">
              POSITIONING
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              我们把自己定位成什么
            </h2>
            <div className="mt-5 flex flex-col gap-4 text-[15px] leading-8 text-foreground-700">
              <p>
                不是八卦媒体，也不是审判庭。瓜田观察更像一间透明的观察室：把一场吃瓜事件里散落的评论区声音收集起来，按风向分类、按热度排序，让围观的人花更少的力气看懂更多。
              </p>
              <p>
                我们不追独家、不抢首发，也不靠情绪标题吸引点击。我们相信真正有价值的信息，往往藏在第三条高赞评论里，而不是通稿的第一段。
              </p>
            </div>
          </div>
          <div>
            <span className="text-xs font-bold tracking-[0.25em] text-primary-600">
              PHILOSOPHY
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              发展理念
            </h2>
            <div className="mt-5 flex flex-col gap-4 text-[15px] leading-8 text-foreground-700">
              <p>
                吃瓜本身没有错，错的是被情绪牵着走。我们想让围观变得更清醒一点：看到支持的声音，也看到反对的理由，然后自己做判断。
              </p>
              <p>
                所以我们从不关闭评论区、从不隐藏反对意见，也不为了流量放大对立。一个健康的瓜田，应该让每一种声音都被完整看见。
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="principles" className="scroll-mt-24 border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
          <span className="text-xs font-bold tracking-[0.25em] text-primary-600">PRINCIPLES</span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            内容原则
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            这四条是我们所有内容都会遵守的底线，也是你能信任这里的前提。
          </p>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
            {PRINCIPLES.map((item) => (
              <div
                key={item.title}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-2xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <h3 className="font-heading text-lg font-bold text-foreground-950">近期收录的专题</h3>
            <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
              {featured.map((event) => (
                <Link
                  key={event.id}
                  to={`/event/${event.id}`}
                  className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3"
                >
                  <span className="h-14 w-20 shrink-0 overflow-hidden rounded-md">
                    <img
                      src={event.cover}
                      alt={`${event.title} - 专题配图`}
                      title={event.title}
                      className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </span>
                  <span className="min-w-0">
                    <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                      {event.title}
                    </span>
                    <span className="mt-1 block text-xs text-foreground-500">
                      {event.categoryLabel}
                    </span>
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="reviews" className="scroll-mt-24 border-b border-background-200 bg-background-50">
        <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
          <span className="text-xs font-bold tracking-[0.25em] text-primary-600">REVIEWS</span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            用户口碑
          </h2>
          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {REVIEWS.map((review) => (
              <figure
                key={review.name}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  “{review.content}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 text-sm font-black text-background-50">
                    {review.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-bold text-foreground-950">
                      {review.name}
                    </span>
                    <span className="block text-xs text-foreground-500">{review.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100">
        <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
          <div className="flex flex-col gap-6 rounded-lg border border-background-200 bg-background-50 p-6 md:flex-row md:items-center md:justify-between md:p-8">
            <div>
              <h2 className="font-heading text-2xl font-black text-foreground-950">联系我们</h2>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
                内容纠错、事件投稿、合作咨询，都可以直接发邮件给我们。工作日内一般 24 小时内回复。
              </p>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                rel="nofollow"
                className="mt-4 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-mail-send-line text-lg" />
                {CONTACT_EMAIL}
              </a>
            </div>
            <div className="flex shrink-0 flex-col gap-3 rounded-lg bg-background-100 p-5">
              <p className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-line text-lg text-secondary-600" />
                内容纠错：核实后 24 小时内处理
              </p>
              <p className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-line text-lg text-secondary-600" />
                事件投稿：请附公开来源链接
              </p>
              <p className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-line text-lg text-secondary-600" />
                商务合作：请在邮件标题注明来意
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}